<template>
  <div class="detail">
    <mt-navbar v-model="selected">
      <mt-tab-item id="0">优秀</mt-tab-item>
      <mt-tab-item id="1">良好</mt-tab-item>
      <mt-tab-item id="2">一般</mt-tab-item>
    </mt-navbar>
    <div class="enterpriseList bg_fff">
      <p v-show= "list.length" v-for="(item, index) in list" :key="index" class="enterpriseItem fs14 bg_fff">
        {{item}}
      </p>
        <p v-show= "!list.length" class="enterpriseItem fs14 bg_fff">该分段暂无企业</p>
    </div>
  </div>
</template>

<script>
export default {
    name: "EnterpriseDistributionDetail",
    data() {
        return {
          selected: "0",
          list: [],
        }
    },
    methods: {
      getData: function() {

      }
    },
    mounted() {
      this.selected = this.$route.params.index || "0";
      if (this.$route.params.list) {
        const index = Number(this.$route.params.index);
        this.list = this.$route.params.list[index]?.companies;
      } else {
        this.$router.push({path: '/enterpriseDistribution'});
      }
    },
    watch: {
      "selected": function(cur) {
        this.list = this.$route.params.list[Number(cur)]?.companies;
      }
    }
}
</script>

<style lang="scss" scoped>
.detail {
  .mint-tab-item.is-selected {
    border-bottom: 0.04rem solid #023A9F;
    color: #000000;
    .mint-tab-item-label {
      font-weight: bold;
    }
  }
  .enterpriseList {
    margin-top: 20px;
    .enterpriseItem {
      height: 30px;
      line-height: 30px;
      margin-left: 20px;
    }
  }
}
</style>

<style lang="scss">
.mint-tab-item {
  .mint-tab-item-label {
    font-size: 0.18rem;
  }
}
.mint-tab-item.is-selected {
  .mint-tab-item-label {
    font-weight: bold;
    font-size: 0.2rem;
  }
}
</style>

